import { render, staticRenderFns } from "./CheckboxesGroup.vue?vue&type=template&id=aa2bf4a6"
import script from "./CheckboxesGroup.vue?vue&type=script&lang=js"
export * from "./CheckboxesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports